export default __webpack_public_path__ + "static/media/avatar-normal-geometric-18.af46c646.svg";